export default __webpack_public_path__ + "507f490f70d4191fb77267f66800ae32.png";